export default [ 'api', 'availabilityCacheService', function (api, availabilityCacheService) {
  let switchEventType = (eventType) => {
    switch (eventType.toLowerCase()) {
    case 'treatment':
      return 'treatments';
    case 'day':
    case 'spaday':
    case 'spa day':
      return 'spa-days';
    case 'activity':
      return 'activities';
    default:
      return null;
    }
  };

  return {
    switchEventType,
    uncacheDate: (eventType, eventId, date) => availabilityCacheService.uncacheDate(eventType, eventId, date),

    requestAvailability: (fromDate, toDate, eventType, eventId, offerId = null) => {
      let cached = availabilityCacheService.datesCached(eventType, eventId, fromDate, toDate);

      if (cached.length) {
        return Promise.resolve(cached);
      }

      let url = `${switchEventType(eventType)}/${eventId}/availability?from_date=${fromDate}&to_date=${toDate}`;

      if (offerId) {
        if (typeof offerId === 'object') {
          offerId = offerId.id;
        }
        url += `&offer_id=${offerId}`;
      }

      return api.get(url)
        .then(response => {
          availabilityCacheService.updateCache(eventType, eventId, response.data);
          return response.data;
        });
    },

    requestAvailabilityList: (date, eventType, eventIds = null, offerId = null) => {
      let url = `${switchEventType(eventType)}/availability?date=${date}`;

      if (eventIds) {
        url += `&event_ids=${eventIds.join(',')}`;
      }

      if (offerId) {
        url += `&offer_id=${offerId}`;
      }

      return api.get(url)
        .then(response => response.data);
    },

    requestCreditAvailabilityList: (date) => {
      return api.get(`treatments/availability/credit?date=${date}`)
        .then(response => response.data);
    },

    requestOfferDetails: (offerId) => {
      return api.get(`offers/${offerId}`)
        .then(response => response.data);
    },

    requestExternalAvailability: (eventType, dateFrom, dateTo, externalId) => {
      return api.get(`api/externalAvailability/${switchEventType(eventType)}/${externalId}?date_from=${dateFrom}&date_to=${dateTo}`)
        .then(response => response.data);
    }
  };
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/availability/services/availability.api.service.js